import { render, staticRenderFns } from "./FeedCustomLinkEntry.vue?vue&type=template&id=0160b024&scoped=true&"
import script from "./FeedCustomLinkEntry.vue?vue&type=script&lang=ts&"
export * from "./FeedCustomLinkEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FeedCustomLinkEntry.vue?vue&type=style&index=0&id=0160b024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160b024",
  null
  
)

export default component.exports